import React, { useCallback, useEffect } from "react";
import { useRecoilState } from "recoil";
// atoms
import waterInTakeTrackingAtom from "src/recoil/atoms/waterInTakeTrackingAtom";
// __apis__
import { fetchWaterInTakeStatus } from "src/__apis__/waterInTakeTracking";

// ---------------------------------------------------------------------------------------------------

function useWaterInTakeTracking() {
  const [waterInTake, setWaterInTake] = useRecoilState(waterInTakeTrackingAtom);

  const waterInTakeTrackingFetcher = useCallback(async () => {
    fetchWaterInTakeStatus()
      .then((response) => {
        setWaterInTake(response.water_in_take);
      })
      .catch((error) => {
        console.log("Error fetching water in take status", error);
      });
  }, []);

  useEffect(() => {
    waterInTakeTrackingFetcher();
  }, []);

  return [waterInTake, waterInTakeTrackingFetcher];
}

export default useWaterInTakeTracking;
